import React from "react";
import { currentTimeInMinutes, timeToMinutes } from "../utils";
import { HappyHourTime } from "./Time";

function EstablishmentHappyHoursList({
  groupedHappyHours,
  activeDay,
  fullDayNames,
  happyHours,
  name,
  establishmentId,
  handleWish,
  votes,
  pollLoading,
}) {
  const currentDay = fullDayNames[activeDay.value];
  const isVoted = votes[`${establishmentId}-${currentDay}`];

  const renderHappyHours = () => {
    if (Object.entries(groupedHappyHours).length > 0) {
      const hasHappyHoursForDay = happyHours?.some((item) => {
        const fields = item?.fields;
        if (!fields) return false;
        return fields["Happy Hour Day"].includes(currentDay);
      });

      if (hasHappyHoursForDay) {
        return Object.entries(groupedHappyHours)
          .sort(
            ([timeA], [timeB]) => timeToMinutes(timeA) - timeToMinutes(timeB)
          )
          .map(([time, happyHours], index) => {
            const [startTime, endTime] = time.split("-");
            const validHappyHoursForDay = happyHours?.filter((happyHour) =>
              happyHour?.fields["Happy Hour Day"]?.includes(currentDay)
            );

            if (validHappyHoursForDay.length === 0) {
              return null;
            }

            const isCurrentTimeWithinHappyHour =
              currentTimeInMinutes() >= timeToMinutes(startTime) &&
              currentTimeInMinutes() <= timeToMinutes(endTime);

            return (
              <div key={index} className="my-4">
                <HappyHourTime
                  isCurrentTimeWithinHappyHour={isCurrentTimeWithinHappyHour}
                  startTime={startTime}
                  endTime={endTime}
                  isunderline={true}
                />
                <ul className="list-none">
                  {validHappyHoursForDay.map((happyHour, index) => (
                    <li key={index}>
                      <p
                        key={index}
                        className={`text-xl my-2 ${
                          isCurrentTimeWithinHappyHour
                            ? "font-medium text-[#fff] sm:text-base md:text-xl tracking-wide bg-white bg-opacity-5 px-4 py-4 rounded inline-block"
                            : "font-regular md:text-base"
                        }`}
                      >
                        {happyHour.fields["Happy Hour Offer"]}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            );
          });
      }
    }

    return (
      <div className="my-4">
<p className="text-base text-[#989995] font-regular mb-2">
  No Happy Hours for <span className="text-[#fff]">{currentDay}</span>
</p>        <div className="hidden bg-white bg-opacity-10 rounded-lg p-2 relative">
          {pollLoading && (
            <div className="absolute top-0 bottom-0 left-0 right-0 h-full bg-black bg-opacity-85 w-full">
              <div
                className="h-full flex justify-center items-center"
                role="status"
              >
                <svg
                  aria-hidden="true"
                  className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-main-orange-200"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          <p
            className={`text-center mb-1 text-white mt-2 ${
              isVoted ? "hidden" : ""
            }`}
          >
            {`Do you wish ${name}`}
            <br />
            {`offered a happy hour for ${currentDay}?`}
          </p>
          <div className="flex justify-center space-x-4 mt-3 mb-2">
            {isVoted ? (
              <p>Thank you for voting!</p>
            ) : (
              <>
                <button
                  onClick={() => handleWish(establishmentId, currentDay, "yes")}
                  className="px-4 py-2 bg-yellow-500 text-black font-bold text-xs rounded"
                >
                  Yes
                </button>
                <button
                  onClick={() => handleWish(establishmentId, currentDay, "no")}
                  className="px-4 py-2 bg-[#14252B] text-white font-bold text-xs rounded"
                >
                  No
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return <div className="px-2">{renderHappyHours()}</div>;
}

export default EstablishmentHappyHoursList;
